module.controller(
    'clientDetailCtrl',
    [ '$scope', '$rootScope', '$state', 'clientService', 'alertService', 'parameterService',
        function($scope, $rootScope, $state, clientService, alertService, parameterService) {

            $scope.operationType = $state.current.data.type;
            $scope.idClient = $state.params.id;
            $scope.client = {
            	idType: {}
            };
            $scope.loading = false;

            
            parameterService.getDefaultIdentificationType().then(function(response) {
            	$scope.client.idType = {
            			selected: [response.getData()]
            	};
            }, function(response) {
            	
            }); 
            
            /**
             *
             * @param idUser
             */
            $scope.load = function(idClient) {
                $scope.loading = true;

                clientService.getClient(idClient).then(function(response) {
                    $scope.loading = false;

                    var responseData = response.getData();
                    $scope.client = {
                      name : responseData.name,
                      businessName : responseData.businessName,
                      idType: {
                    	  selected: [{
                    		  id: responseData.identificationType.id,
                    		  name: responseData.identificationType.name,
                    		  value: responseData.identificationType.value
                    		 }]
                      },
                      identificationNumber : responseData.identificationNumber,
                      mainAddress : responseData.mainAddress
                    };
                }, function(response) {
                    $scope.loading = false;
                });
            };

            /**
             *
             */
            $scope.sendAction = function() {
                if ($scope.operationType == 'create') {
                    $scope.create();
                } else {
                    $scope.update();
                }
            };

            /**
             *
             */
            $scope.create = function() {
                alertService.showSwtQuestion('Crear Cliente', function() {
                    $scope.loading = true;

                    var createModel = {
                    	name: $scope.client.name,
                    	businessName: $scope.client.businessName,
                    	idIdentificationType: $scope.client.idType.selected[0].id,
                    	identificationNumber: $scope.client.identificationNumber,
                    	mainAddress: $scope.client.mainAddress
                    };

                    clientService.createClient(createModel).then(function(response) {
                        $scope.loading = false;
                        alertService.showSuccess('Cliente creado satisfactoriamente');
                        $state.go('home.clientList');
                    }, function(response) {
                        $scope.loading = false;
                    });
                });
            };

            /**
             *
             */
            $scope.update = function() {
                alertService.showSwtQuestion('Actualizar Cliente', function() {
                    $scope.loading = true;

                    var updateModel = {
                        	name: $scope.client.name,
                        	businessName: $scope.client.businessName,
                        	idIdentificationType: $scope.client.idType.selected[0].id,
                        	identificationNumber: $scope.client.identificationNumber,
                        	mainAddress: $scope.client.mainAddress
                        };
                    
                    clientService.updateClient($scope.idClient, updateModel).then(function(response) {
                        $scope.loading = false;
                        alertService.showSuccess('Cliente actualizado satisfactoriamente');
                        $state.go('home.clientList');
                    }, function(response) {
                        $scope.loading = false;
                    });
                });
            };


            $scope.goBack = function() {
            	if($scope.idClient){
            		var params = {
            				id: $scope.idClient
            		};
            		$state.go('home.clientHome', params);
            	}
            	else{
            		$state.go('home.clientList');
            	}
            };
            
            if ($scope.operationType == 'update') {
                $scope.load($state.params.id);
            }

        } ]);


